module.exports = __webpack_public_path__ + "img/denmark-other-heart-diseases-male.c4246841.png";